import { createContext } from "react";

const NfcListContext = createContext({});

export default NfcListContext;
